import { render, staticRenderFns } from "./CompanyChangePlan.vue?vue&type=template&id=67a38ff0&scoped=true&"
import script from "./CompanyChangePlan.vue?vue&type=script&lang=js&"
export * from "./CompanyChangePlan.vue?vue&type=script&lang=js&"
import style0 from "./CompanyChangePlan.vue?vue&type=style&index=0&id=67a38ff0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67a38ff0",
  null
  
)

export default component.exports